import { getQueryParameters } from "../Wizards/Entities/QueryParametersHelper";
import { ClientAccount } from "../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { RestrictionStore } from "../../Dashboard/Components/Clients/Common/Restrictions/Variable";
import { ActionType } from "../../../react-core/Flux/ActionType";
import { RestrictionAction } from "../../Dashboard/Components/Clients/Common/Restrictions/RestrictionAction";
import { CommonHelper } from "../../../react-core/Helpers/CommonHelper";
import { IWizardComponentStateGeneric, WizardComponentGeneric } from "./WizardComponentGeneric";

export interface IWizardComponentState extends IWizardComponentStateGeneric {
    clientInfo: any;
    extraInfo?: any;
    clientAccount?: ClientAccount;
    isRestrictionLoading?: boolean;
}
export abstract class WizardComponent extends WizardComponentGeneric<IWizardComponentState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(RestrictionStore, () => this.onRestrictionStoreChange());
    }
    private onRestrictionStoreChange() {
        if (RestrictionStore.getActionType() == ActionType.Success) {
            this.setState({ isRestrictionLoading: false });
        }
    }
    componentDidMount() {
        if (!CommonHelper.isNullOrEmpty(getQueryParameters()["subaccounthierarchyid"])) {
            RestrictionAction.getRestrictionByHierarchyId(getQueryParameters()["subaccounthierarchyid"]);
        } else if (!CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])) {
            RestrictionAction.getRestrictionByHierarchyId(getQueryParameters()["hierarchyid"]);
        } else {
            this.setState({ isRestrictionLoading: false });
        }
    }

    initState() {
        this.state = {
            data: null,
            clientInfo: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            extraInfo: {},
            isRestrictionLoading: true,
        };
    }
}
